import { floor } from 'lodash'

export const secondsToHumanReadable = (seconds?: number) => {
  if (!seconds) {
    return ''
  }

  let remainder = seconds
  let ret = ''
  const units = [
    { unit: 'd', count: 86400 },
    { unit: 'h', count: 3600 },
    { unit: 'm', count: 60 },
    { unit: 's', count: 1 },
  ]
  units.forEach(({ unit, count }) => {
    if (remainder < count) {
      return
    }

    const units = floor(remainder / count)
    remainder -= units * count
    ret += `${units}${unit}`
  })

  return ret
}
